<template>
  <div>
    <SmsAuthWithPhoneSwitch
      v-if="isSms"
      title="電話番号認証"
      :phoneNumber="phoneNumber"
      :createSms="createSms"
      :validateSms="validateSms"
      @switchToVoice="switchProvider('phone')"
      @validated="onValidated"
    />
    <PhoneAuth
      v-else-if="isVoice"
      title="電話番号認証"
      :phoneNumber="phoneNumber"
      :createPhoneRequest="createPhoneRequest"
      :validatePhoneRequest="validatePhoneRequest"
      @switchToSMS="switchProvider('sms')"
      @validated="onValidated"
    />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-facing-decorator";
import { smsService } from "@/app/services/SmsService";
import { authStore } from "@/store/auth";
import SmsAuthWithPhoneSwitch from "@/components/organisms/auth/SmsAuthWithPhoneSwitch.vue";
import PhoneAuth from "@/components/organisms/auth/PhoneAuth.vue";
import { CreateSmsArgs } from "@/types/auth/CreateSms";
import { ValidateSmsArgs } from "@/types/auth/ValidateSms";
import { CreatePhoneRequestArgs } from "@/types/auth/CreatePhoneRequest";
import { ValidatePhoneRequestArgs } from "@/types/auth/ValidatePhoneRequest";
import { accountService } from "@/app/services/AccountService";
import { ProviderType } from "@/const/auth";

@Component({
  components: {
    SmsAuthWithPhoneSwitch,
    PhoneAuth
  }
})
export default class EditPhoneNumberAuth extends Vue {
  providerType: ProviderType = "sms";

  get phoneNumber() {
    return authStore.temporaryPhoneNumber;
  }

  get isSms() {
    return this.providerType === "sms";
  }

  get isVoice() {
    return this.providerType === "phone";
  }

  createSms(body: CreateSmsArgs) {
    return smsService.createSms(body);
  }

  validateSms(body: ValidateSmsArgs) {
    return smsService.validateSms(body);
  }

  createPhoneRequest(body: CreatePhoneRequestArgs) {
    return smsService.createPhoneRequest(body);
  }

  validatePhoneRequest(body: ValidatePhoneRequestArgs) {
    return smsService.validatePhoneRequest(body);
  }

  async onValidated(smsSessionId: string) {
    await this.updatePhoneNumber(smsSessionId);
    await this.transition();
  }

  async updatePhoneNumber(smsSessionId: string) {
    if (!smsSessionId || !this.phoneNumber) return;

    const body = {
      smsSessionId: smsSessionId,
      phoneNumber: this.phoneNumber
    };

    return await accountService.updatePhoneNumber(body);
  }

  switchProvider(provider: ProviderType) {
    this.providerType = provider;
  }

  async transition() {
    await this.$bvModal.msgBoxOk("電話番号を変更しました", {
      okVariant: "success",
      centered: true
    });
    await this.$router.push({ name: "Mypage" });
  }
}
</script>
